var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coins") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-7",
    className: "cls-4",
    d: "M17,14.5c0,1.93-2,3.5-4.5,3.5S8,16.43,8,14.5,10,11,12.5,11,17,12.57,17,14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,19c-3,0-5.5-2-5.5-4.5S9.47,10,12.5,10,18,12,18,14.5,15.53,19,12.5,19Zm0-7C10.6,12,9,13.14,9,14.5S10.6,17,12.5,17,16,15.86,16,14.5,14.4,12,12.5,12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-8",
    className: "cls-4",
    d: "M17,11.5c0,1.93-2,3.5-4.5,3.5S8,13.43,8,11.5,10,8,12.5,8,17,9.57,17,11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,16c-3,0-5.5-2-5.5-4.5S9.47,7,12.5,7,18,9,18,11.5,15.53,16,12.5,16Zm0-7C10.6,9,9,10.15,9,11.5S10.6,14,12.5,14,16,12.85,16,11.5,14.4,9,12.5,9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-9",
    className: "cls-4",
    d: "M17,8.5c0,1.93-2,3.5-4.5,3.5S8,10.43,8,8.5,10,5,12.5,5,17,6.57,17,8.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,13C9.47,13,7,11,7,8.5S9.47,4,12.5,4,18,6,18,8.5,15.53,13,12.5,13Zm0-7C10.6,6,9,7.15,9,8.5S10.6,11,12.5,11,16,9.85,16,8.5,14.4,6,12.5,6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-12",
    className: "cls-4",
    d: "M17,5.5C17,7.43,15,9,12.5,9S8,7.43,8,5.5,10,2,12.5,2,17,3.57,17,5.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.5,10C9.47,10,7,8,7,5.5S9.47,1,12.5,1,18,3,18,5.5,15.53,10,12.5,10Zm0-7C10.6,3,9,4.15,9,5.5S10.6,8,12.5,8,16,6.85,16,5.5,14.4,3,12.5,3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-4",
    className: "cls-4",
    d: "M12,17.5c0,1.93-2,3.5-4.5,3.5S3,19.43,3,17.5,5,14,7.5,14,12,15.57,12,17.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.5,22c-3,0-5.5-2-5.5-4.5S4.47,13,7.5,13,13,15,13,17.5,10.53,22,7.5,22Zm0-7C5.6,15,4,16.14,4,17.5S5.6,20,7.5,20,11,18.86,11,17.5,9.4,15,7.5,15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-5",
    className: "cls-4",
    d: "M12,14.5c0,1.93-2,3.5-4.5,3.5S3,16.43,3,14.5,5,11,7.5,11,12,12.57,12,14.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.5,19c-3,0-5.5-2-5.5-4.5S4.47,10,7.5,10,13,12,13,14.5,10.53,19,7.5,19Zm0-7C5.6,12,4,13.14,4,14.5S5.6,17,7.5,17,11,15.86,11,14.5,9.4,12,7.5,12Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-6",
    className: "cls-4",
    d: "M12,11.5c0,1.93-2,3.5-4.5,3.5S3,13.43,3,11.5,5,8,7.5,8,12,9.57,12,11.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.5,16c-3,0-5.5-2-5.5-4.5S4.47,7,7.5,7,13,9,13,11.5,10.53,16,7.5,16Zm0-7C5.6,9,4,10.15,4,11.5S5.6,14,7.5,14,11,12.85,11,11.5,9.4,9,7.5,9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-10",
    className: "cls-4",
    d: "M21,19c0,1.1-1.34,2-3,2s-3-.9-3-2,1.34-2,3-2S21,17.9,21,19Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,22c-2.24,0-4-1.32-4-3s1.76-3,4-3,4,1.32,4,3S20.24,22,18,22Zm0-4c-1.2,0-2,.6-2,1s.8,1,2,1,2-.6,2-1S19.2,18,18,18Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3-Copy-11",
    className: "cls-4",
    d: "M21,16c0,1.1-1.34,2-3,2s-3-.9-3-2,1.34-2,3-2S21,14.9,21,16Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18,19c-2.24,0-4-1.32-4-3s1.76-3,4-3,4,1.32,4,3S20.24,19,18,19Zm0-4c-1.2,0-2,.6-2,1s.8,1,2,1,2-.6,2-1S19.2,15,18,15Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.67d53c72d265b63c92951b8d86268904.svg";
export { ForwardRef as ReactComponent };